
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/mongodb",
      function () {
        return require("private-next-pages/destinations/mongodb.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/mongodb"])
      });
    }
  